let reduceFunction = function(result, item) {
  let parts = item.split('=');
  result[parts[0]] = parts[1];

  return result;
};

let buildQuery = function(params = []) {
  let url = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  if (Object.keys(params).length) {
    url += '?';

    for (let i in params) {
      url += `${i}=${params[i]}&`;
    }

    return url.substr(0, url.length - 1);
  }

  return url;
};

let getAll = function() {
  let params = document.location.search ? document.location.search.substr(1) : null;
  let returnParams = [];

  if (params) {
    returnParams = params.split('&').reduce(reduceFunction, {});
  }

  return returnParams;
};

export default {
  getAll: getAll,
  buildQuery: buildQuery
};
